<template></template>

<script>
    import ModelPanel from "../modeling/ModelPanel";
    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        name: 'event-storming-model-panel',
        mixins: [ModelPanel],
        props: {
            newEditUserImg:{
                type: Array,
                default: function () {
                    return []
                }
            },
            validationLists:{
                type: Array,
                default: function () {
                    return []
                }
            },
            widthStyle: {
                type: String,
                default: function () {
                    return 'width: 500px;'
                }
            },
        },
        data: function () {
            return {
                // common
                // namePanel: '',
                // descriptionPanel: '',
                AggregateRulePanelStatus: false,
                ruleRequired: value => !!value || 'Required.',
                openValidationLists:false,
                validationLevelIcon:
                    {
                      'error' : {icon: 'mdi-close-circle-outline', color:'#E53935'},
                      'warning' : {icon: 'mdi-alert-outline', color:'#FFA726'},
                      'info' : {icon: 'mdi-information-outline', color:'#29B6F6'},
                    },

                // command, external
                restfulList: ['GET', 'POST', 'PATCH', 'DELETE', 'PUT'],


                // translate
                usedTranslate: false,
                translateText: '',

                // relatedUrl
                relatedUrlDialog: false,
                relatedUrl: null,
            }
        },
        created() {
            var me = this
            // open created : me.$options.name: event-storming-model-panel / $parent.$options.name   : actor-definition
            // load created : me.$options.name: actor-definition           / $parent.$options.name   : opengraph
            // destroy name : me.$options.name: event-storming-model-panel / $parent.$options.name   : actor-definition
            if (me.$route.path.includes('replay')) {
                this.$emit('update:widthStyle','width:500px; margin-right:17.5%;')
            }
        },
        computed: {
            isHexagonalModeling() {
                if (this.canvasbase) {
                    return this.canvasbase.isHexagonalModeling
                }
                return false
            },
            translateObj(){
                return {'usedTranslate': this.usedTranslate , 'translateText': this.translateText}
            },
            getImage(){
              if(this.image){
                  return this.image
              }
              return null;
            },
            titleName() {
                if(this.value){
                    return this.value ? this.value._type.split('.')[4] : null
                }
                return null;

            },
            panelWidthStyle() {
                return this.widthStyle
            },
            elementAuthorDisplay() {
                var me = this
                var str = null
                if (me.canvasbase && me.canvasbase.information) {
                    if (me.value && me.value.author && me.canvasbase.information.author) {

                        if (me.value.author == me.canvasbase.information.author) {
                            str = me.canvasbase.information.authorEmail
                        } else if (me.canvasbase.information.permissions) {
                            var userInfo = me.canvasbase.information.permissions[me.value.author]
                            if (userInfo) {
                                str = userInfo.userName
                            } else {
                                str = '권한 없는 유저'
                            }
                        } else {
                            str = null
                        }
                        return str;
                    }
                }
                return str;
            },

        },
        beforeDestroy() {
            var me = this
            me.executeBeforeDestroy()
        },
        watch: {
            value: {
                deep:true,
                handler: _.debounce(function (newVal, oldVal) {
                    if( oldVal ){
                       // open 말고.
                       this.$emit('changedPanelValue', this.value)
                    }
                }, 300)
            },
            "value.name": _.debounce(async function (newVal) {
                var me = this
                    me.changedNamePanel(me.value.name)
            }, 500),
            "value.description": _.debounce(async function (newVal) {
                var me = this
                    me.changedDescriptionPanel(me.value.description)
            }, 500),
            // value: {
            //     deep: true,
            //     handler: _.debounce(function (newVal,oldVal) {
            //         var me = this
            //         if(oldVal){
            //             me.stayClosePanelCheck()
            //             me.stayOpenPanelCheck()
            //         }
            //     }, 1000)
            // }
        },
        methods: {
            //<<<<<<<<<<<<<<<<<<<<<<<<<<< Panel Methods
            // stayOpenPanelCheck(){
            //     var me = this
            //     var getComponent =  null
            //
            //     if(me.$options.name == 'event-storming-model-panel'){
            //         getComponent = me.$parent
            //     }else if(me.$parent.$options.name == 'opengraph'){
            //         getComponent = me
            //     }
            //     //
            //     if(getComponent && !getComponent.isPassedClosePanel){
            //         getComponent.staySetTimeout = setTimeout(function () {
            //             if(getComponent.newEditUserImg && getComponent.newEditUserImg[0] ){
            //                 /*
            //                     isPassedClosePanel : 정보변경 제외
            //                     close : 판넬 닫힘
            //                     panelClose : 수정중인 사람 닫힘.
            //                  */
            //                 getComponent.isPassedClosePanel = true
            //                 getComponent.close()
            //                 getComponent.panelClose(getComponent.newEditUserImg[0])
            //             }
            //         }, 3 * 60 * 1000)
            //     }
            // },
            // stayClosePanelCheck(){
            //     var me = this
            //     var getComponent =  null
            //     if(me.$options.name == 'event-storming-model-panel'){
            //         //opne
            //         getComponent = me.$parent
            //     }else if(me.$parent.$options.name == 'opengraph'){
            //         getComponent = me
            //     }
            //
            //     if(getComponent){
            //         getComponent.isPassedClosePanel = false
            //         clearTimeout(getComponent.staySetTimeout)
            //     }
            // },
            closePanel(){
                this.$emit('close')
            },
            panelInit() {
                try {
                    var me = this
                    // console.log('PANEL_INIT :: COMMON')
                    //init setting
                    // me.copyValue = JSON.parse(JSON.stringify(me.value))

                    // only sticker
                    // me.namePanel = me.value.name
                    // me.descriptionPanel = me.value.description

                    if (me.isServerModeling
                        && me.isQueueModeling
                        && !me.isClazzModeling
                        && !me.isReadModeling
                        && !me.isHexagonalModeling
                    ) {
                        me.panelOpenQueue()
                    }
                } catch (e) {
                    console.log('[Error] ES Panel Init: ', e)
                }

            },
            executeBeforeDestroy() {
                var me = this
                try{
                    /*
                        _value : 기존 값.
                        value  : Panel 사용되는 값,
                    */
                    var diff = jsondiffpatch.diff(me._value, me.value)
                    if (diff && !(Object.keys(diff).includes('aggregate') && Object.keys(diff).length == 1)) {
                        console.log('Panel - executeBeforeDestroy')
                        if (!me.readOnly) {
                            me.canvasbase.changedByMe = true

                            // part sync
                            me._value.oldName = JSON.parse(JSON.stringify(me._value.name))

                            // all sync
                            Object.keys(me.value).forEach(function (itemKey) {
                                if(itemKey == 'oldName'){
                                    // Exception : part sync
                                }else if(itemKey != 'elementView' || itemKey != 'relationView'){
                                    // Exception: 위치정보
                                    me._value[itemKey] = JSON.parse(JSON.stringify(me.value[itemKey]))
                                }
                            })
                            // re setting 값을 emit
                            me.$emit('_value-change', me._value)
                        }
                    }

                    if (me.isServerModeling
                        && me.isQueueModeling
                        && !me.isClazzModeling
                        && !me.isReadModeling
                        && !me.isHexagonalModeling
                    ) {
                        me.panelCloseQueue()
                    }
                }catch (e) {
                    alert('[Error] EventStormingPanel Sync: ', e)
                }
            },
            changedDescriptionPanel(newVal) {
                var me = this
                if (me.value.elementView)
                    me.canvasbase.$refs[`${me.value.elementView.id}`][0].descriptionPanel = newVal ? newVal : ''
                else if (me.value.relationView)
                    me.canvasbase.$refs[`${me.value.relationView.id}`][0].descriptionPanel = newVal ? newVal : ''
            },
            async changedNamePanel(newVal) {
                var me = this
                var translateObj = null

                if (me.value.elementView)
                    me.canvasbase.$refs[`${me.value.elementView.id}`][0].namePanel = newVal ? newVal : ''
                else if (me.value.relationView)
                    me.canvasbase.$refs[`${me.value.relationView.id}`][0].namePanel = newVal ? newVal : ''
            },
            // Panel Methods >>>>>>>>>>>>>>>>>>>>>>>>>>

            // <<<<<<<<<<<<<<<<<<<<<<<<<<  Translate
            changeTranslate(newVal) {
                console.log('changeTranslate::::: ', newVal)
                this.value.name = this.translateText
                this.usedTranslate = false
            },
            getTranslate(){
                return new Promise(async function (resolve) {
                    resolve(null);
                })
            },
            // getTranslate:
            //     _.debounce(
            //         function () {
            //             try {
            //                 return null;
            //             } catch (e) {
            //                 return undefined;
            //                 // console.log(`[Error-Translate]:${e} `)
            //             }
            //         }, 500
            //     ),
            // Translate   >>>>>>>>>>>>>>>>>>>>>>>>>

            // <<<<<<<<<<<<<<<<<<<<< Common Methods
            //event, command
            findAssociatedAggregate() {
                var me = this

                me.value.aggregate = {}
                if (Object.values(me.canvasbase.attachedLists.aggregateLists).length > 0) {

                    Object.values(me.canvasbase.attachedLists.aggregateLists).forEach(function (agg, index) {
                        var outer = {
                            x: (agg.elementView.x - agg.elementView.width / 2) - 10,
                            y: (agg.elementView.y - agg.elementView.height / 2) - 10,
                            width: agg.elementView.width + 20,
                            height: agg.elementView.height + 20
                        }

                        var inner = {
                            x: me.value.elementView.x - me.value.elementView.width / 2,
                            y: me.value.elementView.y - me.value.elementView.height / 2,
                            width: me.value.elementView.width,
                            height: me.value.elementView.height
                        }


                        if (me.canvasbase._isAttached(outer, inner)) {
                            me.value.aggregate = agg;
                        }
                    })
                }
            },
            isEmptyObject(obj) {
                var boolean = false
                if (obj == null) return true;
                if (Object.keys(obj).length == 0) return true;

                Object.keys(obj).some(function (vari) {
                    if (!vari.includes('relation')) {
                        boolean = Object.keys(obj[vari]).length === 0 && obj.constructor === Object
                        return true
                    }

                })

                return boolean
            },
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
</style>